/*
 * Monte Vista sign-up form (sections/sbtc-mv-camp.liquid).
 * Reads campers from the form, prices them with window.SBTCMVCamp, then swaps the
 * camp lines in the cart for the freshly priced ones.
 */
(function () {
  'use strict';

  var MAX_CAMPERS = 8;

  function money(n) {
    return '$' + n.toFixed(0);
  }

  function readConfig(root) {
    var node = root.querySelector('[data-sbmv-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function readCampers(list) {
    return Array.prototype.map.call(list.children, function (li) {
      var days = Array.prototype.filter.call(li.querySelectorAll('input[name="day"]'), function (box) {
        return box.checked;
      }).map(function (box) { return Number(box.value); });
      return {
        name: li.querySelector('input[name="name"]').value,
        grade: li.querySelector('select[name="grade"]').value,
        days: days
      };
    });
  }

  function renumber(list) {
    Array.prototype.forEach.call(list.children, function (li, i) {
      var num = li.querySelector('[data-sbmv-num]');
      num.textContent = i === 0 ? 'Camper 1' : 'Camper ' + (i + 1);
      var hint = num.querySelector('small') || document.createElement('small');
      hint.textContent = i === 0 ? 'Holds the $30 first seat on each day' : '$15 on any day another camper is already booked';
      num.appendChild(hint);
    });
  }

  function renderSummary(root, config, result) {
    var linesEl = root.querySelector('[data-sbmv-lines]');
    var totalEl = root.querySelector('[data-sbmv-total]');
    var weekEl = root.querySelector('[data-sbmv-week]');
    var submit = root.querySelector('[data-sbmv-submit]');
    linesEl.textContent = '';

    if (result.lines.length === 0) {
      var empty = document.createElement('li');
      empty.className = 'is-empty';
      empty.textContent = 'Tick at least one day to see your total.';
      linesEl.appendChild(empty);
    }

    result.lines.forEach(function (line) {
      var li = document.createElement('li');
      var left = document.createElement('span');
      var right = document.createElement('span');
      left.textContent = config.dayLabels[line.day] + ' · ' + (line.child || 'Camper') + ' · ' + line.seat;
      right.textContent = money(window.SBTCMVCamp.PRICES[line.seat]);
      li.appendChild(left);
      li.appendChild(right);
      linesEl.appendChild(li);
    });

    var total = window.SBTCMVCamp.total(result.lines);
    totalEl.textContent = money(total);
    weekEl.hidden = !result.fullWeek;
    submit.textContent = total > 0 ? 'Add to cart · ' + money(total) : 'Add to cart';
  }

  // Preview pricing even before names and grades are filled in.
  function previewResult(campers) {
    var filled = campers.map(function (c, i) {
      return { name: c.name.trim() || 'Camper ' + (i + 1), grade: c.grade || '-', days: c.days };
    }).filter(function (c) { return c.days.length > 0; });
    if (filled.length === 0) return { lines: [], fullWeek: false, errors: [] };
    return window.SBTCMVCamp.buildLines(filled);
  }

  function showErrors(root, errors) {
    var box = root.querySelector('[data-sbmv-errors]');
    box.textContent = '';
    errors.forEach(function (msg) {
      var p = document.createElement('p');
      p.textContent = msg;
      box.appendChild(p);
    });
  }

  function flagInvalid(list) {
    Array.prototype.forEach.call(list.children, function (li) {
      var name = li.querySelector('input[name="name"]');
      var grade = li.querySelector('select[name="grade"]');
      name.setAttribute('aria-invalid', String(!name.value.trim()));
      grade.setAttribute('aria-invalid', String(!grade.value));
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function replaceCampLines(config, items) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not read your cart.');
        return res.json();
      })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if (item.product_id === config.productId) updates[item.key] = 0;
        });
        return Object.keys(updates).length ? postJSON('/cart/update.js', { updates: updates }) : null;
      })
      .then(function () {
        return postJSON('/cart/add.js', { items: items });
      });
  }

  function init(root) {
    var config = readConfig(root);
    var form = root.querySelector('[data-sbmv-form]');
    if (!config || !form || !window.SBTCMVCamp) return;

    var list = root.querySelector('[data-sbmv-campers]');
    var tpl = root.querySelector('[data-sbmv-tpl]');
    var addBtn = root.querySelector('[data-sbmv-add]');
    var submit = root.querySelector('[data-sbmv-submit]');

    function refresh() {
      renderSummary(root, config, previewResult(readCampers(list)));
      addBtn.hidden = list.children.length >= MAX_CAMPERS;
    }

    function addCamper() {
      list.appendChild(tpl.content.firstElementChild.cloneNode(true));
      renumber(list);
      refresh();
    }

    list.addEventListener('input', refresh);
    list.addEventListener('change', refresh);
    list.addEventListener('click', function (event) {
      var li = event.target.closest('.sbmv__camper');
      if (event.target.closest('[data-sbmv-remove]') && list.children.length > 1) {
        li.remove();
        renumber(list);
        refresh();
        return;
      }
      if (event.target.closest('[data-sbmv-all]')) {
        var boxes = li.querySelectorAll('input[name="day"]');
        var allOn = Array.prototype.every.call(boxes, function (b) { return b.checked; });
        Array.prototype.forEach.call(boxes, function (b) { b.checked = !allOn; });
        refresh();
      }
    });
    addBtn.addEventListener('click', addCamper);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var result = window.SBTCMVCamp.buildLines(readCampers(list));
      flagInvalid(list);
      showErrors(root, result.errors);
      if (result.errors.length) return;

      var items;
      try {
        items = window.SBTCMVCamp.toCartItems(result.lines, config.variants);
      } catch (err) {
        showErrors(root, ['Sign-up is misconfigured. Please email hello@sbtrapezeco.com.']);
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Adding…';
      replaceCampLines(config, items)
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          submit.disabled = false;
          showErrors(root, [err.message || 'Something went wrong. Please try again.']);
          refresh();
        });
    });

    addCamper();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sbmv]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
